import { render, staticRenderFns } from "./iconPlusInvoice.vue?vue&type=template&id=64509932"
import script from "./iconPlusInvoice.vue?vue&type=script&lang=js"
export * from "./iconPlusInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports